import { useEffect, useRef, useState } from 'react';

import { BuyBox } from './components/BuyBox';
import { Header } from './components/Header';
import { Pill } from './components/Pill';
import { SubHeader } from './components/SubHeader';
import * as Styled from './HeroSection.style';

import { useProductLandingContext } from '../../contexts/useProductLanding';

function HeroSection() {
  const { productConfig } = useProductLandingContext();
  const { hero } = productConfig;

  const { headline, headerPicture, subheader, intro, partnerLogo, partnerReviewBlanks, pill, subHeaderAlign } = hero;

  const buyBoxRef = useRef(null);
  const [buyBoxHeight, setBuyBoxHeight] = useState(0);

  useEffect(() => {
    if (buyBoxRef.current) {
      setBuyBoxHeight(buyBoxRef.current.offsetHeight);
    }
  }, []);

  return (
    <Styled.HeroContainer buyBoxHeight={buyBoxHeight}>
      {pill?.text && <Pill text={pill.text} color={pill.bgcolor} />}
      <Styled.HeroContent>
        <Header title={headline} image={headerPicture} />
        <SubHeader
          text={subheader}
          intro={intro}
          logo={partnerLogo}
          reviews={partnerReviewBlanks}
          align={subHeaderAlign}
        />
        <BuyBox ref={buyBoxRef} />
      </Styled.HeroContent>
    </Styled.HeroContainer>
  );
}

export default HeroSection;
